import {DataCollector} from '../DataCollector';
import {Promise, strings} from '@securionpay-internal/commons-js';
import {TokenRequest} from "../../types/request/TokenRequest";
import kountSDK, {KountSdkConfig} from '@kount/kount-web-client-sdk';
import {KountMerchantConfig} from "../../types/response/MerchantConfig";

export class KountDataCollector implements DataCollector {
    private readonly _sessionId: string;
    private _finished: Promise<void>;

    constructor(
        private readonly _config: KountMerchantConfig) {
        this._sessionId = strings.random(32)
        this._finished = this.startCollector();
    }

    private startCollector = () => new Promise((resolve) => {
        const kountConfig: KountSdkConfig = {
            clientID: this._config.clientId,
            environment: this._config.environment,
            isSinglePageApp: false,
            isDebugEnabled: false,
            callbacks: {
                'collect-end': () => resolve(undefined)
            }
        };
        kountSDK(kountConfig, this._sessionId)
    });

    processTokenRequest(request: TokenRequest): Promise<void> {
        // always add session id, so we can use partial collection on timeout
        request.fraudCheckData = request.fraudCheckData || {}
        request.fraudCheckData.sessionId = this._sessionId
        return this._finished;
    }
}